<template>
  <!-- pop-approve-serg -->
  <div class="popup_in">
    <div class="popup pop-delete-block">
      <div v-if="isRequestBlock" class="">
        <div class="title bold" style="font-size: 36px;">
          בקשתך הועברה בהצלחה למוקד חדר ניתוח לבדיקה.
        </div>
        צוות המוקד ייצור קשר תוך יום עסקים אחד להמשך טיפול בבקשתך.
      </div>
      <div v-else class="title bold">
        הבלוק שוריין לבקשתך ויאושר סופית ע״י צוות מוקד הניתוחים תוך יום עבודה
        אחד
      </div>
      <a
        class="bt_blue bt-approveDelete w-100"
        href="javascript:void(0)"
        @click.prevent="onClose"
      >
        סגור
      </a>
    </div>
  </div>
  <!-- End pop-approve-serg -->
</template>

<script>
import { getHash } from "../../utilities/hash.js";

export default {
  name: "ConfirmSurgBlock",
  props: ["date", "isRequestBlock"],
  methods: {
    async onClose() {
      if (this.isRequestBlock) {
        this.$router.push(`/dashboard/surgeries`);
      } else {
        const date = this.$moment(this.date).format("YYYY-MM-DD");
        const hash = getHash({ date: date, view: "day" });
        await this.$router.push(`/dashboard/surgeries#${hash}`);
      }
      this.$emit("close");
    }
  }
};
</script>

<style scoped></style>
